export default function FormRow({ label, children }) {
  return (
    <div className="form-row">
      <label>{label}</label>
      <div className="form-field">{children}</div>
    </div>
  );
}
